import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms'

export function matchPasswordsValidator(newPasswordKey: string, confirmPasswordKey: string): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const passwordField = control.get(newPasswordKey)
    const confirmPasswordField = control.get(confirmPasswordKey)

    if (!passwordField || !confirmPasswordField) {
      console.log('One or both of the password keys is missing. Fix the form.')
      return { couldNotFindBothPasswords: true }
    }

    const password = passwordField?.value
    const confirm = confirmPasswordField?.value

    if (password != confirm) {
      return { noMatch: true }
    }

    return null
  }
}
